import React from 'react';
import { TelemetryPanelConfig } from '../types/telemetry-dashboard.types';
import { useTelemetryLayoutContext } from './TelemetryLayout';
import { getTelemetryPanelWrapperStyle, TelemetryGapZone } from '../utils/telemetry-grid.utils';
import { TelemetryGapZoneUI } from './TelemetryGapZone';

export interface TelemetryPanelWrapperProps {
  panel: TelemetryPanelConfig | any;
  index: number;
  onGapInsert?: (gap: TelemetryGapZone) => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const TelemetryPanelWrapper: React.FC<TelemetryPanelWrapperProps> = ({
  panel,
  index,
  onGapInsert,
  children,
  className = '',
  style,
}) => {
  const layoutCtx = useTelemetryLayoutContext();
  const isDrag = layoutCtx.dragId === panel.id;
  const isResize = layoutCtx.resizeId === panel.id;
  const wrapStyle = getTelemetryPanelWrapperStyle(panel, layoutCtx as any);

  return (
    <React.Fragment>
      <div
        id={`telemetry-panel-wrapper-${panel.id}`}
        className={`telemetry-panel-wrapper ${isDrag ? 'telemetry-panel--dragging' : ''} ${isResize ? 'telemetry-panel--resizing' : ''} ${className}`}
        style={{ ...wrapStyle, ...style }}
      >
        {children}
      </div>

      {/* List Mode Insertion Zone below every item */}
      {layoutCtx.layoutMode === 'list' && onGapInsert && (
        <TelemetryGapZoneUI
          mode="list"
          onInsert={() =>
            onGapInsert({
              key: `gap-list-${panel.id}`,
              orient: 'h',
              panelW: 12,
              panelH: 3,
              y: panel.y + panel.h,
              left: 0,
              top: 0,
              width: 0,
              height: 0,
            })
          }
        />
      )}
    </React.Fragment>
  );
};
